import { render, staticRenderFns } from "./atcProjectItem.vue?vue&type=template&id=38144f24&"
import script from "./atcProjectItem.vue?vue&type=script&lang=ts&"
export * from "./atcProjectItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports